import IconSuitcaseLarge from '@adv-mt/mt-svg-icons/lib/SuitcaseLarge.js'
import IconSuitcaseMedium from '@adv-mt/mt-svg-icons/lib/SuitcaseMedium.js'
import IconSuitcaseOutline from '@adv-mt/mt-svg-icons/lib/SuitcaseOutline.js'

const LUGGAGE_CAPACITIES = {
  SMALL: 1,
  MEDIUM: 2,
  LARGE: 3
}

export const ICONS_BY_LUGGAGE_CAPACITY = {
  [LUGGAGE_CAPACITIES.SMALL]: IconSuitcaseOutline,
  [LUGGAGE_CAPACITIES.MEDIUM]: IconSuitcaseMedium,
  [LUGGAGE_CAPACITIES.LARGE]: IconSuitcaseLarge
}
